module.exports = __webpack_public_path__ + "zmenseni-prsou_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_2_before.jpg
// module id = 1280
// module chunks = 0